/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsHeaderConfig } from '../lds-header.data';
import styled from 'styled-components';

export const HeaderImages: React.FC<ILdsHeaderConfig> = props => {
    const Header = styled.div`
        display: flex;
        justify-content: space-around;
    `;

    const HeaderImageWrapper = styled.div`
        display: flex;
    `;
    // const churchWidth = 'auto';
    // const churchWidthMobile = 'auto';

    // const churchHeight = 'auto';
    // const churchHeightMobile = 'auto';

    // const storeWidth = 'auto';
    // const storeWidthMobile = 'auto';

    // const storeHeight = 'auto';
    // const storeHeightMobile = 'auto';
    // const ChurchLogo = styled.a`
    //     width: ${churchWidth};
    //     height: ${churchHeight};

    //     @media (max-width: 600px) {
    //         width: ${churchWidthMobile};
    //         height: ${churchHeightMobile};
    //     }
    // `;

    // const StoreLogo = styled.a`
    //     width: ${churchWidth};
    //     height: ${churchHeight};

    //     @media (max-width: 600px) {
    //         width: ${churchWidthMobile};
    //         height: ${churchHeightMobile};
    //     }
    // `;

    const churchLogoLink = props.churchLink ? props.churchLink : '';
    const churchLogoImage = props.churchImage ? props.churchImage : '';

    const storeLogoLink = props.storeLink ? props.storeLink : '';
    const storeLogoImage = props.storeImage ? props.storeImage : '';

    return (
        <Header>
            <HeaderImageWrapper>
                <a className='ChurchLogo' href={churchLogoLink ? churchLogoLink.linkUrl.destinationUrl : ''}>
                    <img
                        src={churchLogoImage && churchLogoImage.src ? churchLogoImage.src : ''}
                        alt={churchLogoImage && churchLogoImage.alt ? churchLogoImage.alt : 'LdsChurchImage'}
                    />
                </a>
                <a className='StoreLogo' href={storeLogoLink ? storeLogoLink.linkUrl.destinationUrl : ''}>
                    <img
                        src={storeLogoImage && storeLogoImage.src ? storeLogoImage.src : ''}
                        alt={storeLogoImage && storeLogoImage.alt ? storeLogoImage.alt : 'LdsStoreImage'}
                    />
                </a>
            </HeaderImageWrapper>
        </Header>
    );
};
